import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  modal: {
    zIndex: 2000,
  },
  container: {
    width: "100vw",
    height: "100svh",
    backgroundColor: "#000000",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(2),
    zIndex: 10,
  },
  closeButton: {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    position: "relative",
  },
  imageWrapper: {
    position: "relative",
    maxWidth: "100%",
    maxHeight: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
    borderRadius: theme.spacing(1),
  },
  controls: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    alignItems: "center",

    "& > button, & > div": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(4px)",
      borderRadius: "50%",
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      },
    },

    // Override RatingControls internal structure
    "& > div": {
      "& > div": {
        backgroundColor: "transparent !important",
        padding: "0 !important",
        margin: "0 !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      },

      // Center the icon within RatingControls
      "& svg": {
        margin: "0 !important",
      },

      // Remove any padding from internal buttons
      "& button": {
        padding: "0 !important",
        margin: "0 !important",
      },
    },
  },
  moreButton: {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
    padding: theme.spacing(0.75),
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
  menu: {
    zIndex: 2100,
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1),
    },
  },
  dotsContainer: {
    position: "absolute",
    bottom: theme.spacing(4),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    cursor: "pointer",
    transition: "all 0.2s",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    },
  },
  dotActive: {
    backgroundColor: theme.palette.secondary.main,
    width: 10,
    height: 10,
  },
  smallerRatingControls: {
    "& .MuiIconButton-root": {
      width: "24px !important",
      height: "24px !important",
      padding: "4px !important",

      "& svg": {
        fontSize: "20px !important",
        width: "20px",
        height: "20px",
      },
    },
  },
}));
